import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Bell, ArrowRight } from "lucide-react";

function fmtDate(iso) {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export default function NotificationsPage() {
  const { t } = useI18n();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications")
      .then((r) => {
        setItems(r.data.items || []);
        if (r.data.unread > 0) api.post("/notifications/mark-read").catch(() => {});
      })
      .catch(() => setItems([]));
  }, []);

  const msg = (n) => {
    if (n.type === "helper_apply")
      return t("notif.helper_apply_msg").replace("{author}", n.author || "?");
    if (n.type === "helper_upload")
      return t("notif.helper_upload_msg").replace("{author}", n.author || "?").replace("{n}", n.count ?? "?");
    return t(n.type === "status" ? "notif.status_msg" : "notif.note_msg")
      .replace("{author}", n.author || "?")
      .replace("{a}", n.ante_ref || "?")
      .replace("{b}", n.post_ref || "?")
      .replace("{status}", n.status ? t("review.status." + n.status) : "");
  };

  return (
    <div className="mx-auto max-w-3xl px-6 py-10" data-testid="notifications-page">
      <div className="flex items-center gap-2">
        <Bell size={20} className="text-[#2E3A46]" />
        <h1 className="font-heading text-2xl font-semibold text-[#1A2024]">{t("notif.title")}</h1>
      </div>
      <div className="mt-6 space-y-2">
        {items === null && <p className="font-body text-sm text-[#5C6873]">…</p>}
        {items && items.length === 0 && (
          <p className="font-body text-sm text-[#5C6873]" data-testid="notifications-empty">{t("notif.empty")}</p>
        )}
        {items && items.map((n) => (
          <Link
            key={n.id}
            to={n.link || "/matches"}
            className={`block rounded-lg border px-4 py-3 transition-colors hover:bg-[#F8F9FA] ${n.read ? "border-[#E2E8F0] bg-white" : "border-[#4A7C59]/40 bg-[#4A7C59]/[0.05]"}`}
            data-testid={`notification-${n.id}`}
          >
            <div className="flex items-center justify-between gap-3">
              <p className="font-body text-sm text-[#1A2024]">{msg(n)}</p>
              <ArrowRight size={14} className="flex-shrink-0 text-[#8A96A0]" />
            </div>
            <p className="mt-1 font-body text-[11px] text-[#8A96A0]">{fmtDate(n.created_at)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
